import { selectDimension } from "../../redux/PhoenixActions";
import { dimensions } from "./dimensions";

export const getXDEFlavouredDimensions = (selectedDimensions) => {
    const groupedMap = new Map();
    const dimensionOrder = [];

    dimensions.forEach((dimension) => {
        
        if(!groupedMap.has(dimension.dimensionCategory)) {
            groupedMap.set(dimension.dimensionCategory, {
                                                            colHelp : dimension.categoryDisplayName,
                                                            colId : dimension.dimensionCategory,
                                                            colText : dimension.categoryDisplayName,
                                                            mandatoryYN : "N",
                                                            fieldType: null,
                                                            groupId : "Optional",
                                                            selected : false,
                                                            expand : false,
                                                            dropDowns : []
                                                        });
        }
        const exists = selectedDimensions.indexOf(dimension.dimensionCategory+'|'+dimension.dimension) != -1 ? true : false;

        groupedMap.get(dimension.dimensionCategory).dropDowns.push({
                                                colHelp : dimension.displayName,
                                                colId : dimension.dimensionCategory+'|'+dimension.dimension,
                                                colText : dimension.displayName,
                                                mandatoryYN : "N",
                                                fieldType: null,
                                                groupId : "Optional",
                                                selected : exists,
                                                expand : false,
                                                dropDowns : []});

        if(exists){
            dimensionOrder.push({
                colHelp : dimension.displayName,
                colId : dimension.dimensionCategory+'|'+dimension.dimension,
                colText : dimension.displayName,
                mandatoryYN : "N",
                fieldType: null,
                groupId : "Optional",
                selected : exists,
                expand : false,
                dropDowns : []})
        }

    });

    const xdeFlavouredDimensions = Array.from(groupedMap.values());

    return {xdeFlavouredDimensions, dimensionOrder};
}

export const getXDEFlavouredDimensionOrder = (selctedDimensions) => {
    const xdeOrder = [];
    selctedDimensions.map(dimension => {
        xdeOrder.push({
            colHelp : dimension.displayName,
            colId : dimension.dimensionCategory+'|'+dimension.dimension,
            colText : dimension.displayName,
            dropDowns : [],
            expand : false,
            selected : true
        })
    });

    return xdeOrder;
}

export const getPhoenixFlavouredDimension = (xdeDimensions, analysisLevel) => {
    const v2DimColumnCode = {
        "RiskCountryCode": "AssetCountryOfRisk",
        "TradeCountryCode": "AssetCountryOfIssue",
		"TickerID": "Ticker"
    };

    return xdeDimensions.map(dimension => {
        const [name, rawColumn] = dimension.colId.split('|');
        const column = v2DimColumnCode[rawColumn] || rawColumn;

        if (analysisLevel?.key === 'Hierarchy') {
            return { name, column };
        }
        return { name, column, isSubTotal: false, isTotal: false };
    });
};